import English from '../constants/lang/English.json';
import French from '../constants/lang/French.json';

export const LOCALE_EN = 'en';
export const LOCALE_FR = 'fr';

const CONTEXT_DATA_KEY_SESSION_STORAGE = 'contextData';

export function getSessionStorageKey() {
  return CONTEXT_DATA_KEY_SESSION_STORAGE;
}
export function hasSessionStorageSupport() {
  let storage;
  try {
    storage = window['sessionStorage'];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0)
    );
  }
}

export function getSessionStorage() {
  return hasSessionStorageSupport() && window.sessionStorage;
}

export function getContextDataFromSessionStorage() {
  try {
    return JSON.parse(getSessionStorage().getItem(CONTEXT_DATA_KEY_SESSION_STORAGE));
  } catch (e) {
    return false;
  }
}

export function setContextDataToSessionStorage(contextData) {
  const storage = getSessionStorage();
  if (storage) {
    storage.setItem(CONTEXT_DATA_KEY_SESSION_STORAGE, JSON.stringify(contextData));
  }
}

export function getMesssagesForLocale(locale) {
  let language = '';
  switch (locale) {
    case LOCALE_EN: {
      language = English;
      break;
    }
    case LOCALE_FR: {
      language = French;
      break;
    }
    default: {
      language = English;
    }
  }
  return language;
}
